import { createContext, FC, ReactNode } from 'react';
import { ICMSBreadcrumb } from 'shared/types/Breadcrumbs';

interface IBreadcrumbsProvider {
  children: ReactNode;
  breadcrumbs: ICMSBreadcrumb[];
}

export const BreadcrumbContext = createContext(null);

const BreadcrumbContextProvider: FC<IBreadcrumbsProvider> = ({ children, breadcrumbs }) => (
  <BreadcrumbContext.Provider value={{ ...breadcrumbs }}>{children}</BreadcrumbContext.Provider>
);

export default BreadcrumbContextProvider;
